import useTranslation from 'next-translate/useTranslation';
import styles from './styles.module.scss';
import { WalletService } from '@starsoft/common/services';
import { Button, ErrorCard } from '@starsoft/common/components';
import { useUnavailableBalanceModal } from '@/hooks/unavailable-balance/useUnavailableBalanceModal';
import DepositBoost from '@/components/core/DepositBoost';

export default function UnavailableBalanceModalContent() {
  const { t } = useTranslation('common');
  const {
    error,
    handleError,
    isLoading,
    betAmount,
    wallet,
    balance,
    onClick,
    showBonusLayout,
  } = useUnavailableBalanceModal();

  if (error) {
    return <ErrorCard error={error} refetch={handleError} />;
  }

  return (
    <div className={styles.container}>
      {isLoading ? (
        <div className={styles.container__column}>
          {Array.from({ length: 4 }).map((_, i) => (
            <div
              key={`description_skeleton_${i}`}
              className={styles.container__skeleton}
            />
          ))}
        </div>
      ) : (
        <>
          {showBonusLayout && <DepositBoost />}
          <p className={styles.container__text}>
            {t('insufficient_funds_description', {
              balance,
              betAmount: WalletService.maskCurrency({
                amount: betAmount,
                coin: wallet?.currentAccount?.coin,
              }),
            })}
          </p>
        </>
      )}

      <Button onClick={onClick} className={styles.container__button}>
        {t('tab_deposit')}
      </Button>
    </div>
  );
}
